module.exports = __webpack_public_path__ + "img/ctrl.f34bfa2b.svg";